<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Drivers</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Drivers
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>All Drivers</h4>
                </div>

                <div class="card-body">
                    <div class="mb-2">
                        <form @submit.prevent="paginatedData">
                                <div class="d-flex justify-content-center mt-2 mb-2">
                                    <div class="col-xl-4 col-md-6">
                                        <label>Search</label><br/>
                                        <input type="text" v-model="searchTerm"
                                               class="form-control"
                                               placeholder="🔎 Search this table (Name, email, phone)"
                                               @keyup="paginatedData"
                                        >
                                    </div>
                                    <div class="col-xl-4 col-md-6">
                                        <label>Verification Status</label><br/>
                                        <select class="form-control" v-model="filter.verification_status">
                                            <option value="">All</option>
                                            <option value="verified">Verified</option>
                                            <option value="unverified">Unverified</option>
                                        </select>
                                    </div>

                                    <div class="col-xl-4 col-md-6">
                                        <label>&nbsp;</label><br/>
                                        <button type="submit" class="btn btn-primary">Filter</button>
                                        <button type="button" class="btn btn-default" @click="resetFilter">Reset</button>
                                    </div>
                                </div>
                            </form>
                    </div>

                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        @on-page-change="onPageChange"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allDrivers"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <span v-else-if="props.column.field === 'email'">
                                <a :href="`mailto:${props.row.email}`">{{ props.row.email }}</a>
                            </span>
                            <span v-else-if="props.column.label === 'Name'">
<!--                               <a :href="route('admin.drivers.show', props.row.id)">{{-->
                                <!--                                       props.row.first_name + ' ' + props.row.last_name-->
                                <!--                                   }}</a>-->
                                {{
                                    props.row.first_name + ' ' + props.row.last_name
                                }}
                            </span>
                            <span v-else-if="props.column.label === 'Status'">
                                    <b>Verification Status:</b>
                                    <span class="badge"
                                          :class="{ 'badge-primary': props.row.is_verified,  'badge-info': !props.row.is_verified}">{{
                                            props.row.is_verified ? 'Verified' : 'Not verified'
                                        }}</span>
                                    <br>
                                    <b>Account Status:</b>
                                    <span class="badge"
                                          :class="{ 'badge-primary': props.row.is_active, 'badge-danger': !props.row.is_active}">{{
                                            props.row.is_active ? 'Active' : 'Deactivated'
                                        }}</span>
                                </span>
                            <span v-else-if="props.column.field === 'created_at'">
                                {{ formatDateTime(props.row.created_at) }}
                            </span>
                            <span v-else-if="props.column.field === 'last_seen'">
                                {{ formatDateTime(props.row.last_seen) }}
                            </span>
                            <span v-else-if="props.column.field === 'action'">
                                <span class="dropdown">
									<a id="btnSearchDrop2" data-toggle="dropdown" aria-haspopup="true"
                                       aria-expanded="false" class="dropdown-toggle dropdown-menu-right"><i
                                        class="fa fa-ellipsis-v"></i></a>
                                    <span aria-labelledby="btnSearchDrop2"
                                          class="dropdown-menu mt-1 dropdown-menu-right"
                                          x-placement="bottom-end"
                                          style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(0px, 19px, 0px);"
                                          x-out-of-boundaries="">
                                        <a class="dropdown-item text-secondary"
                                           :href="route('admin.drivers.show', props.row.id)"> <i
                                            class="feather icon-eye"></i> View Driver Details</a>
                                        <a class="dropdown-item text-secondary"
                                           :href="route('admin.drivers.document', props.row.id)"> <i
                                            class="feather icon-eye"></i> View Uploaded Documents</a>
                                        <a href="#"
                                           @click.prevent="updateStatus(props.row.id, props.row.is_active)"
                                           class="dropdown-item">
                                                      <i class="feather icon-check"></i>
                                                {{ !props.row.is_active ? 'Activate ' : 'Deactivate ' }} Account
                                            </a>
                                        <a v-if="!props.row.is_verified" href="#"
                                           @click.prevent="verifyAccount(props.row.id, props.row.is_verified)"
                                           class="dropdown-item">
                                                      <i class="feather icon-check"></i>
                                                {{ !props.row.is_verified ? 'Verify ' : 'Refute' }} Account
                                            </a>
<!--                                        <div class="dropdown-divider"></div>-->
                                        <a href="#" @click.prevent="showAlert(props.row.id)" class="dropdown-item text-danger delete"><i
                                            class="feather icon-trash-2"></i> Delete</a>

                                    </span>
                                </span>
                            </span>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';

export default {
    metaInfo: {title: 'Driver'},
    props: ['drivers'],
    name: "DriverIndex",
    layout: Layout,

    data: () => ({
        filter: {
            verification_status: '',
            status: ''
        },
        isLoadingFilter: false,
        allDrivers: [],
        searchDriver:{},
        totalRecords: 0,
        serverParams: {
            page: 1,
            perPage: 10
        },
        paginationOptions: {
            enabled: true,
            mode: 'pages',
            perPage: 10,
            perPageDropdown: [5, 10, 20, 50, 100, 200],
            dropdownAllowAll: false,
        },
        columns: [
            {label: 'S/N', field: 'sn'},
            {label: 'Name', field: 'name'},
            {label: 'Email', field: 'email'},
            {label: 'Phone', field: 'phone_number'},
            {label: 'Last Seen', field: 'last_seen'},
            {label: 'Date Joined', field: 'created_at'},
            {label: 'Status', field: 'status'},
            {label: 'Action', field: 'action', sortable: false},
        ],
        tableDataLoading: false,
        searchTerm: '',
    }),
    created() {
        this.allDrivers = this.drivers.data
        this.totalRecords = this.drivers.total
    },
    methods: {
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({page: params.currentPage});
            this.paginatedData();
        },
        onPerPageChange(params) {
            this.updateParams({perPage: params.currentPerPage});
            this.paginatedData();
        },
        onSortChange(params) {
            this.serverParams.sort = {
                type: params[0].type,
                field: params[0].field,
            }
            this.paginatedData();
        },
        async paginatedData() {
            try {
                let url = route('admin.drivers.index') +
                    `?q=${this.searchTerm}&page=${this.serverParams.page}&perPage=${this.serverParams.perPage}&verification_status=${this.filter.verification_status}`;

                let {data: {data: {drivers}}} = await axios.get(url);

                this.totalRecords = drivers.total;
                this.paginationOptions.perPage = drivers.per_page;
                this.allDrivers = drivers.data
            } catch (e) {
                console.log(e);
            }
        },

        async resetFilter() {
            this.filter = {}
            this.searchTerm = ""

            this.paginatedData();
        },
        updateStatus(driverId, currentStatus) {
            try {
                let routeName = 'admin.drivers.account.activate';
                if (currentStatus !== 0) {
                    routeName = 'admin.drivers.account.deactivate';
                }

                this.$inertia.patch(route(routeName, driverId), {
                    'status': currentStatus
                }, {
                    preserveScroll: true,
                    onSuccess: () => {
                        const driverIndex = this.allDrivers.findIndex(a => driverId === a.id);
                        this.allDrivers[driverIndex].is_active = this.allDrivers[driverIndex].is_active === 1 ? 0 : 1;
                    },
                });
            } catch (e) {
                console.log(e);
                this.saving = false
            }
        },

        verifyAccount(driverId, currentStatus) {
            try {
                let routeName = 'admin.drivers.account.verify';

                this.$inertia.put(route(routeName, driverId), {
                    'status': currentStatus
                }, {
                    preserveScroll: true,
                    onSuccess: (response) => {
                        if (! response.props.flash.error) {
                            const driverIndex = this.allDrivers.findIndex(a => driverId === a.id);
                            this.allDrivers[driverIndex].is_verified = this.allDrivers[driverIndex].is_verified === 1 ? 0 : 1;
                        }
                    },
                });
            } catch (e) {
                console.log(e);
                this.saving = false
            }
        },

        deleteAccount(driverId) {
            try {
                let routeName = 'admin.drivers.account.delete';

                this.$inertia.post(route(routeName, driverId), {
                    '_method' : 'delete'
                }, {
                    preserveScroll: true,
                    onSuccess: (response) => {
                        if (! response.props.flash.error) {
                            this.paginatedData();
                        }
                    },
                });
            } catch (e) {
                console.log(e);
                this.saving = false
            }
        },

        showAlert(accountId) {
            let vInstance = this;

            this.$swal.fire({
                title: "Are you sure you want to delete this Driver?",
                text: "You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!",
                confirmButtonClass: "btn btn-primary mr-3",
                cancelButtonClass: "btn btn-danger ml-1",
                buttonsStyling: false
            }).then(function (result) {
                if (result.value) {
                    vInstance.deleteAccount(accountId)
                }
            });
        },

        serialNo(props) {
            return this.serverParams.page === 1 ? props.index + 1 : (this.serverParams.perPage *
                    (this.serverParams.page - 1)) +
                props.index + 1
        },

        formatDateTime(value) {
            if (! value) return value

            const date = new Date(value);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}`;
        },
    }
}
</script>
